import {ModuleWithProviders, NgModule} from '@angular/core';
import {ErrorService} from './error-service.service';
import {NotificationService} from './notification.service';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PermissionService} from "./permission.service";
import {CommonModule} from "@angular/common";
import {NotificationComponent} from "./components/notification/notification.component";
import {HttpVersionInterceptor} from "./http-version.interceptor";

@NgModule({
    declarations: [
        NotificationComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
    ]
})
export class ServicesModule {

    static forRoot(): ModuleWithProviders<ServicesModule> {
        return {
            ngModule: ServicesModule,
            providers: [
                ErrorService,
                NotificationService,
                PermissionService,
                HttpVersionInterceptor
            ]
        };
    }

}
